export { default } from './Dashboard'


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/Dashboard/index.js